import { useCallback } from 'react';
import WorkspaceAPI from '../../workspace/WorkspaceAPI';
import _ from 'lodash';
import RightsApi from '../RightsAPI';

const WORKSPACE_MANAGER = 'workspaceManager';
/**
 * Hook to check if the user has WorkspaceManager right in the main workspace
 * Fetches user rights and workspaces, then validates the permission
 */
export const useWorkspaceManagerRight = () => {
  const [triggerRights, { isLoading: isLoadingRights }] =
    RightsApi.endpoints.getMyRights.useLazyQuery();
  const [triggerWorkspaces, { isLoading: isLoadingWorkspaces }] =
    WorkspaceAPI.endpoints.getMyWorkspaces.useLazyQuery();

  const getPermission = useCallback(async () => {
    const { data: rightsResult } = await triggerRights();
    const { data: workspaces } = await triggerWorkspaces(undefined);

    const mainWorkspace = _.last(
      _.sortBy(workspaces, (workspace) => workspace.parentId === null)
    );

    if (!rightsResult || rightsResult.length === 0 || !mainWorkspace) {
      return false;
    }

    // Check if user has WorkspaceManager right for this workspace's scope
    const workspaceScope = `workspace:${mainWorkspace.id}`;

    const hasPermission = rightsResult.some((rightData) => {
      // Check if scope matches the workspace or is master (*)
      const scopeMatches =
        rightData.scope === workspaceScope || rightData.scope === '*';
      // Check if the WorkspaceManager right exists
      const hasRight = rightData.name === WORKSPACE_MANAGER;

      return scopeMatches && hasRight;
    });
    return hasPermission;
  }, [triggerRights, triggerWorkspaces]);

  const isChecking = isLoadingRights || isLoadingWorkspaces;

  return {
    getPermission,
    isLoadingRights: isChecking,
  };
};
